<div matDialogTitle>Uppdatera Docker auktorisering</div>
<mat-dialog-content>
  <p>Här kan vi lida oss igenom att skapa auktorisering för Dockers på GitLab. Ett elände från start till slut.
    Du kan uppdatera både Sparbanken och Akiru på samma gång. Bara välj vilken först innan du uppdaterar.</p>
  <p>Börja med att skapa ett <i>token</i>&nbsp; <a
    href="https://gitlab.com/-/user_settings/personal_access_tokens?page=1&state=active&sort=expires_asc"
    target="_blank">här</a><sup>*</sup>. Det skall endast ha
    <span class="code">read_registry</span>
    och <span class="code">write_registry</span>. Du bör sätta en maximal livslängd på 3 månader.</p>
  <p>När du har ditt <i>token</i> så klistra in det i rutan nedan.</p>
  <p>Ange din epost som du har registrerat på GitLab.</p>
  <div class="form">
    <mat-form-field>
      <mat-label>Välj grupp</mat-label>
      <mat-select [formField]="form.groupId">
        <mat-option value="5335894">Sparbanken Syd</mat-option>
        <mat-option value="61754934">Akiru</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field [style.width.px]="300">
      <mat-label>E-post</mat-label>
      <input [formField]="form.email"
             matInput
             type="text"
      >
    </mat-form-field>
    <mat-form-field [style.width.px]="500">
      <mat-label>Token</mat-label>
      <input [formField]="form.token"
             matInput
             type="text"
      >
      <mat-hint>Obs, inte samma token som du identifierar dig med.</mat-hint>
    </mat-form-field>
  </div>
  <div>
    <p class="subscript"><sup>*</sup> Notera att man inte kan skapa <i>tokens</i> via API. Så det är inte mitt fel.
      Suger gör det i alla
      fall.</p>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-dialog-close matButton="text">Avbryt</button>
  <button
    (click)="generateToken()"
    [disabled]="form().invalid()" matButton="filled">Uppdatera
  </button>
</mat-dialog-actions>
